// Module
var code = ` <button id="pdfExport" class="btn btn-default hidden-print" ng-class="pdfButtonController.viewClasses"> <i class="fa fa-download" aria-hidden="true"></i> <span translate="Page.Evaluation.Report.ExportAsPdf">Export as PDF</span> </button> `;
// Exports
module.exports = code;